import React from 'react';

import { Bookings } from '@components/utilities/Bookings/Bookings';

export const PastBookings: React.FC = () => {
  return <Bookings type="past" />;
};
